// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3mj0Q","title":"AfterFrontImage_title__2-0RO"};